import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Join-the-private-waitlist control. Signed-in users join against their existing
// account email (no form). Visitors are routed through sign-in first.
export default function WaitlistCard({ joined, onJoined, compact = false }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const isJoined = joined || done;

  const join = async () => {
    if (!user) {
      // Send visitors through the existing sign-in flow, then back to membership
      // where they can complete the one-tap waitlist join.
      navigate("/login");
      return;
    }
    setBusy(true);
    try {
      await api.post("/waitlist", {});
      setDone(true);
      toast.success("You're on the list. We'll email you when membership invitations open.");
      onJoined?.();
    } catch {
      toast.error("We couldn't add you just now. Please try again shortly.");
    } finally {
      setBusy(false);
    }
  };

  if (isJoined) {
    return (
      <div className={compact ? "mt-4" : "mt-5"}>
        <div className="flex w-full items-center justify-center gap-2 rounded-full border border-[#D4AF37]/40 bg-[#1a1509] py-3.5" data-testid="waitlist-joined">
          <Check className="h-4 w-4 text-[#D4AF37]" />
          <span className="text-sm font-medium text-[#C8C2B5]">You're on the waitlist.</span>
        </div>
        <p className="mt-2 text-center text-xs text-[#8C8578]" data-testid="waitlist-confirmation">
          You're on the list. We'll email you when membership invitations open.
        </p>
      </div>
    );
  }

  return (
    <button
      data-testid="join-waitlist-button"
      disabled={busy}
      onClick={join}
      className={`${compact ? "mt-4" : "mt-5"} flex w-full items-center justify-center gap-2 rounded-full bg-[#D4AF37] py-3.5 text-base font-semibold text-[#0A0908] hover:bg-[#E5C158] disabled:opacity-60`}
    >
      {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Joining…</> : "Join the Private Waitlist"}
    </button>
  );
}
